import React from "react";
import {useSelector, useDispatch} from "react-redux";

import styles from "./MainFacet.module.scss";
import {
    ACTIVATE_FACET, ACTIVATE_GROUP_WITH_MIDDLEFACETS,
    ACTIVATE_MAIN_FACET,
    ADD_TO_AVAILABLE_GROUPS,
    RESET_AVAILABLE_GROUPS,
    SHOW_MENU, TOGGLE_MENU
} from "../../Store/Actions/ActionTypes";
import getActiveMainFacetID from "../../Utils/getActiveMainFacetID";
import utdanningerIcon from "../../img/Ikoner_Utdanning_large.svg";
import laerestederIcon from "../../img/Ikoner_Læresteder_large.svg";
import artikkelIcon from "../../img/Ikoner_Artikkel-intervju_large.svg";
import yrkerIcon from "../../img/Ikoner_Yrker_large.svg";
import annetIcon from "../../img/Ikoner_Oppgaver-utdanningsvalg_large.svg";
import {fetchMiddlefacets, getMiddlefacetGroups} from "../../Store/Actions/NewFilterActions";

/**
 * ...
 * @arg {string} chevronDownLabel - aria-label for dropdown icon
 * ...
 */
// Component for mainfacets, sets icons etc.
const MainFacet = (props) => {
    const {id, value, count} = props;
    const dispatch = useDispatch();
    const newFilterState = useSelector(state => state.newFilterReducer);
    const facets = newFilterState.facets;
    const showDesktopMenu = newFilterState.showDesktopMenu;
    const responseCache = newFilterState.responseCache;

    let icon;
    switch(value){
        case "Utdanninger":
            icon = utdanningerIcon;
            break;
        case "Verktøy":
            icon = annetIcon;
            break;
        case "Lærested":
            icon = laerestederIcon;
            break;
        case "Artikler":
            icon = artikkelIcon;
            break;
        case "Yrker":
            icon = yrkerIcon;
            break;
        default:
            icon = null;
            break;
    }

    let wrapperClass = `${styles.wrapper}`;
    let isActive = false;
    const activeMainFacetID = getActiveMainFacetID(newFilterState);
    if (activeMainFacetID) {
        if (id === activeMainFacetID) {
            isActive = true;
            wrapperClass += ` ${styles.active}`;
        }
    }

    let arrowClass = `${styles.dropdownicon}`;
    if (isActive) {
        if (showDesktopMenu) {
            arrowClass += ` ${styles.openmenu}`;
        }
        else {
            arrowClass += ` ${styles.closedmenu}`;
        }
    }

    const handleClick = () => {
        let payload;
        if (!isActive) {
            dispatch({type: SHOW_MENU, payload: payload});

            payload = {
                id: id,
                value: value
            };
            dispatch({type: ACTIVATE_MAIN_FACET, payload: payload});

            dispatch({type: RESET_AVAILABLE_GROUPS});
            const groups = facets[id].children;
            payload = {
                groups: groups
            };
            dispatch({type: ADD_TO_AVAILABLE_GROUPS, payload: payload});

            // Below we handle the case that we have a cached selection and we (re)click on a main facet that has
            // middle facets, and one of them was cached.

            const activeFiltersBefore = newFilterState.activeFilters;
            const theFacets = newFilterState.facets;
            const newActiveMainFacet = theFacets[id];
            const selectionCache = newFilterState.selectionCache;

            // Check if the new main_facet has middle facets.
            const theMiddleFacets = newActiveMainFacet.middlefacets;
            if (!Object.keys(theMiddleFacets).length) {
                return;
            }

            // Check if any of the cached filters is the new main facet.
            if (selectionCache[id] === undefined) {
                return;
            }

            // Check if any of the cached filters is one of the middle facets.
            const cachedKeys = Object.keys(selectionCache[id]);
            let cachedMiddleFacet = null;
            let cachedMiddleFacetName = null;
            for (const [middleFacetKey, middleFacetDetails] of Object.entries(theMiddleFacets)) {
                if (cachedKeys.includes(middleFacetKey)) {
                    cachedMiddleFacet = middleFacetDetails;
                    cachedMiddleFacetName = middleFacetKey;
                    break;
                }
            }
            if (!cachedMiddleFacet) {
                // No, none of the cached filters is one of the middle facets.
                return;
            }

            const cachedMiddleFacetID = selectionCache[id][cachedMiddleFacetName].id;
            const cachedMiddleFacetValue = selectionCache[id][cachedMiddleFacetName].value;

            // dispatch({type: CLEAR_ACTIVE_GROUP}); // is it needed?
            dispatch({type: ACTIVATE_GROUP_WITH_MIDDLEFACETS, payload: {id: cachedMiddleFacetName}});
            if (facets[id] !== undefined) {
                if (facets[id].middlefacets[cachedMiddleFacetName].children === undefined) {
                    dispatch(fetchMiddlefacets(responseCache, cachedMiddleFacetName, cachedMiddleFacetName, activeFiltersBefore));
                }
            }
            // dispatch({type: DEACTIVATE_GROUP_WITH_MIDDLEFACETS}); // is it needed?

            const facetPayload = {
                id: cachedMiddleFacetID,
                value: cachedMiddleFacetValue,
                facetName: cachedMiddleFacetName
            };
            dispatch({type: ACTIVATE_FACET, payload: facetPayload});

            const theMiddleGroups = getMiddlefacetGroups(cachedMiddleFacetName, cachedMiddleFacetValue);
            for (const [key, item] of Object.entries(theMiddleGroups)) {
                item.middlefacetGroupID = cachedMiddleFacetName;
                item.middlefacetID = cachedMiddleFacetID;
                item.middlefacetValue = cachedMiddleFacetValue;

                // The facets might have already been fetched from a previous request.
                const cachedMiddlefacetGroup = facets[id].middlefacets[cachedMiddleFacetName];
                const cachedMiddlefacet = cachedMiddlefacetGroup.children[cachedMiddleFacetID];
                if (cachedMiddlefacet.children !== undefined) {
                    // Is the group cached?
                    if (cachedMiddlefacet.children[key] !== undefined) {
                        item.children = cachedMiddlefacet.children[key].children;
                    }
                }
            }
            const groupsPayload = {
                groups: theMiddleGroups
            };
            dispatch({type: ADD_TO_AVAILABLE_GROUPS, payload: groupsPayload});
        }
        else {
            dispatch({type: TOGGLE_MENU, payload: payload});
        }
    };

    return (
        <button onClick={handleClick} className={wrapperClass} id={"mainfacet-" + id} aria-controls="filters+">
            { icon &&
            <img className={styles.icon} src={icon} alt={value + " ikon"}/>
            }
            <span className={styles.text} >
                {value}
                <span className={styles.count}>{count}</span>
            </span>
            <span aria-label={typeof props.chevronDownLabel === `string` || `Åpne`} className={`${arrowClass}`}/>
        </button>
    )
};

export default MainFacet;
